/**
 * useAuthGuard - Check if user is authenticated
 * Mirrors legacy app AuthGuard
 *
 * Checks:
 * - Tokens exist (cookies for internal, sessionStorage for external)
 * - User data exists in sessionStorage
 * - For external users, validates authorization data
 */

import { GuardResult, RouteConfig } from '../types';

/**
 * Auth state passed in from the calling hook (avoids rules-of-hooks violation).
 */
export interface AuthState {
  authenticated: boolean;
  loading: boolean;
  user: any;
  config: { isInternal: boolean } | null;
}

export function checkAuthGuard(route: RouteConfig, auth: AuthState): GuardResult {
  const { authenticated, user, config, loading } = auth;

  // Auth is still loading
  if (loading) {
    return { allowed: false };  // Keep showing loading screen
  }

  // Not authenticated -> redirect to login
  if (!authenticated) {
    return { allowed: false, redirect: '/login' };
  }

  // Internal users - just check token exists
  if (config?.isInternal) {
    // Token should exist from auth service
    return { allowed: true };
  }

  // External users - validate authorization data
  // Must have Providers, OptumId, or HealthCareOrganizationName
  if (!config?.isInternal) {
    const hasProviders = user?.Providers?.length > 0;
    const hasOptumId = user?.OptumId;
    const hasOrgName = user?.HealthCareOrganizationName;

    if (!hasProviders && !hasOptumId && !hasOrgName) {
      console.log('X AuthGuard - External user missing authorization data');
      return { allowed: false, redirect: '/login', error: 'Missing authorization data' };
    }
  }

  return { allowed: true };
}

